import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { confirmExtractedItinerary } from './confirmExtractedItinerary.api'
import {
  ConfirmExtractedItineraryState,
  ConfirmExtractedItinerarySuccessResponse
} from './confirmExtractedItinerary.types'

const initialState: ConfirmExtractedItineraryState = {
  loading: false,
  error: null,
  success: null
}

const confirmExtractedItinerarySlice = createSlice({
  name: 'confirmExtractedItinerary',
  initialState,
  reducers: {
    resetConfirmState: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmExtractedItinerary.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(
        confirmExtractedItinerary.fulfilled,
        (state, action: PayloadAction<ConfirmExtractedItinerarySuccessResponse>) => {
          state.loading = false
          state.error = null
          state.success = action.payload
        }
      )
      .addCase(confirmExtractedItinerary.rejected, (state, action) => {
        state.loading = false
        state.error = (action.payload as string) || 'Failed to confirm itinerary'
        state.success = null
      })
  }
})

export const { resetConfirmState } = confirmExtractedItinerarySlice.actions
export default confirmExtractedItinerarySlice.reducer
